import React, { PureComponent } from 'react'
import Select from 'react-select'

import { NoOptionsMessage, Control, Option, Placeholder, SingleValue, ValueContainer, Menu } from './components'

const components = {
  Control,
  Menu,
  NoOptionsMessage,
  Option,
  Placeholder,
  SingleValue,
  ValueContainer,
}

export class SelectAutocompleteBase extends PureComponent {
  state = {
    suggestions: []
  }

  static getDerivedStateFromProps(nextProps) {
    const { suggestion } = nextProps

    const suggestions = suggestion.map(({ id, label }) => ({
      value: id,
      label: label,
    }))

    return {
      suggestions
    }
  }

  onChange = value => {
    const { name, formValueChange, form } = this.props

    formValueChange(form, name, value)
  }

  render() {
    const { classes, theme, value, ...props } = this.props
    const { suggestions } = this.state

    if (props.formValueChange) {
      delete props.formValueChange
    }

    const selectStyles = {
      input: base => ({
        ...base,
        color: theme.palette.text.primary,
        '& input': {
          font: 'inherit',
        },
      }),
    }

    return (
      <Select
        value={value}
        styles={selectStyles}
        classes={classes}
        options={suggestions}
        onChange={this.onChange}
        components={components}
        {...props}
      />
    )
  }
}

SelectAutocompleteBase.defaultProps = {
  suggestion: []
}



// WEBPACK FOOTER //
// ./src/components/SelectAutocomplete/SelectAutocomplete.js